import React, { useState, useEffect } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";

function ReplyModal({ show, onHide, commentData, meetingId, refreshList }) {
  const [message, setMessage] = useState("");
  const [receiverId, setReceiverId] = useState("");

  useEffect(() => {
    if (commentData) {
      setReceiverId(commentData.sender_id); // Assuming you're replying to the original sender
    }
  }, [commentData]);

  const handleSubmit = () => {
    const bodyFormData = new FormData();
    bodyFormData.append("popup_request_id", meetingId);
    bodyFormData.append("receiver_id", receiverId);
    bodyFormData.append("query", message);
    bodyFormData.append("comment_id", 0);
    bodyFormData.append("parent_id", commentData?.id || 0);

    utils
      .callAPI("post", "meeting/popupgift/query-add", bodyFormData)
      .then((res) => {
        setMessage("");
        onHide();
        refreshList();
      })
      .catch((err) => {
      });
  };

  return (
    <RB.Modal show={show} onHide={onHide} size="lg">
      <RB.Modal.Header closeButton>
        <RB.Modal.Title>
          Replying to: {commentData?.employeeName}
        </RB.Modal.Title>
      </RB.Modal.Header>
      <RB.Modal.Body>
        <RB.Form.Group>
          <RB.Form.Control
            as="textarea"
            rows={3}
            placeholder="Enter your reply..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </RB.Form.Group>
      </RB.Modal.Body>
      <RB.Modal.Footer>
        <RB.Button variant="secondary" onClick={onHide}>
          Cancel
        </RB.Button>
        <RB.Button variant="primary" onClick={handleSubmit} disabled={!message}>
          Submit FeedBack
        </RB.Button>
      </RB.Modal.Footer>
    </RB.Modal>
  );
}

export default ReplyModal;
